import { AuditReportsGipEvidenceExportOptionsDto } from '@mi-front/api-v2';
import { useToast } from '@app/core/notifications';
import { FileUpload as FileUploadIcon } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { GipExportDialog } from './GipExportDialog';
import { gipExportMessages } from './messages';
interface Props {
  readonly retry?: boolean;
  readonly initialConfig?: AuditReportsGipEvidenceExportOptionsDto;
  readonly reportType: string;
  readonly onExport: (config: AuditReportsGipEvidenceExportOptionsDto) => Promise<void>;
  readonly onSuccess?: () => any;
}

export const GipExportLauncher = (p: Props) => {
  const [show, setShow] = useState(false);
  const { $t } = useIntl();
  const { notifyInfo } = useToast();

  return (
    <>
      <Button
        size="small"
        color="warning"
        variant="contained"
        onClick={() => setShow(true)}
        startIcon={<FileUploadIcon />}
      >
        {p.retry ? (
          <FormattedMessage {...gipExportMessages.retryBtn} />
        ) : (
          <FormattedMessage {...gipExportMessages.startBtn} />
        )}
      </Button>
      <GipExportDialog
        show={show}
        onHide={() => setShow(false)}
        initialConfig={p.initialConfig}
        reportType={p.reportType}
        onSubmit={async (options) => {
          try {
            await p.onExport(options);

            notifyInfo($t(gipExportMessages.startNotification));

            setShow(false);
            // p.onSuccess && p.onSuccess();
          } catch (error) {
            notifyInfo($t(gipExportMessages.startNotificationError));
          }
        }}
      />
    </>
  );
};
